module.exports = __webpack_public_path__ + "static/media/cocina.2c039e97.png";